import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';

export function BackButton() {
  const navigate = useNavigate();

  return (
    <motion.button
      onClick={() => navigate('/')}
      className="fixed top-6 left-6 p-3 bg-white/10 rounded-full backdrop-blur-sm 
                 border border-white/20 shadow-lg z-50 
                 hover:bg-white/20 transition-all duration-200
                 text-white/80 hover:text-white"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.2 }}
    >
      <ArrowLeft className="h-6 w-6" />
    </motion.button>
  );
} 